// Shared UI assets only. Keep page-specific registries out of client bundles.
const ICON_BASE_URL = process.env.NEXT_PUBLIC_IMAGE_BASE_URL || "";
import amazonLexIcon from "../icons/ai_chatbot_tech_icons/amazon-lex.svg";
import angularIcon from "../icons/ai_chatbot_tech_icons/angular.svg";
import awsIcon from "../icons/ai_chatbot_tech_icons/aws.svg";
import azureIcon from "../icons/ai_chatbot_tech_icons/azure.svg";
import djangoIcon from "../icons/ai_chatbot_tech_icons/django.svg";
import fastApiIcon from "../icons/ai_chatbot_tech_icons/fast-api.svg";
import flaskIcon from "../icons/ai_chatbot_tech_icons/flask.svg";
import gcpIcon from "../icons/ai_chatbot_tech_icons/gcp.svg";
import googleDialogflowIcon from "../icons/ai_chatbot_tech_icons/google-dialogflow.svg";
import hallucinationControlIcon from "../icons/ai_chatbot_tech_icons/hallucination-control.svg";
import ibmWatsonAssistantIcon from "../icons/ai_chatbot_tech_icons/ibm-watson-assistant.svg";
import llmsIcon from "../icons/ai_chatbot_tech_icons/llms.svg";
import microsoftBotFrameworkIcon from "../icons/ai_chatbot_tech_icons/microsoft-bot-framework.svg";
import microsoftCognitiveToolkitIcon from "../icons/ai_chatbot_tech_icons/microsoft-cognitive-toolkit.svg";
import multiChannelBotsIcon from "../icons/ai_chatbot_tech_icons/multi-channel-bots.svg";
import nodeJsIcon from "../icons/ai_chatbot_tech_icons/node-js.svg";
import promptEngineeringIcon from "../icons/ai_chatbot_tech_icons/prompt-engineering.svg";
import pythonIcon from "../icons/ai_chatbot_tech_icons/python.svg";
import pytorchIcon from "../icons/ai_chatbot_tech_icons/pytorch.svg";
import ragIcon from "../icons/ai_chatbot_tech_icons/rag.svg";
import reactIcon from "../icons/ai_chatbot_tech_icons/react.svg";
import rubyIcon from "../icons/ai_chatbot_tech_icons/ruby.svg";
import spacyIcon from "../icons/ai_chatbot_tech_icons/spacy.svg";
import tensorflowIcon from "../icons/ai_chatbot_tech_icons/tensorflow.svg";
import vectorDatabasesIcon from "../icons/ai_chatbot_tech_icons/vector-databases.svg";
import vuejsIcon from "../icons/ai_chatbot_tech_icons/vuejs.svg";
import aFrameIcon from "../icons/vr_development_tech_icons/a_frame.svg";
import babylonjsIcon from "../icons/vr_development_tech_icons/babylonjs.svg";
import cPlusPlusIcon from "../icons/vr_development_tech_icons/c_plus_plus.svg";
import cSharpIcon from "../icons/vr_development_tech_icons/c_sharp.svg";
import firebaseIcon from "../icons/vr_development_tech_icons/firebase.svg";
import godotIcon from "../icons/vr_development_tech_icons/godot.svg";
import javascriptIcon from "../icons/vr_development_tech_icons/javascript.svg";
import metaQuestDkIcon from "../icons/vr_development_tech_icons/meta_quest_dk.svg";
import openxrIcon from "../icons/vr_development_tech_icons/openxr.svg";
import react360Icon from "../icons/vr_development_tech_icons/react_360.svg";
import steamvrIcon from "../icons/vr_development_tech_icons/steamvr.svg";
import threeJsIcon from "../icons/vr_development_tech_icons/three-js.svg";
import unityIcon from "../icons/vr_development_tech_icons/unity.svg";
import unrealEngineIcon from "../icons/vr_development_tech_icons/unreal_engine.svg";
import arcoreIcon from "../icons/ar_development_tech_icons/arcore.svg";
import arkitIcon from "../icons/ar_development_tech_icons/arkit.svg";
import artoolkitIcon from "../icons/ar_development_tech_icons/artoolkit.svg";
import googleCloudIcon from "../icons/ar_development_tech_icons/google-cloud.svg";
import kotlinIcon from "../icons/ar_development_tech_icons/kotlin.svg";
import maxstIcon from "../icons/ar_development_tech_icons/maxst.svg";
import swiftIcon from "../icons/ar_development_tech_icons/swift.svg";
import vueJsIcon from "../icons/ar_development_tech_icons/vue-js.svg";
import vuforiaIcon from "../icons/ar_development_tech_icons/vuforia.svg";
import webarIcon from "../icons/ar_development_tech_icons/webar.svg";
import wikitudeIcon from "../icons/ar_development_tech_icons/wikitude.svg";
import agentWorkflowsIcon from "../icons/generative_ai_tech_icons/agent-workflows.svg";
import claudeIcon from "../icons/generative_ai_tech_icons/claude.svg";
import dockerIcon from "../icons/generative_ai_tech_icons/docker.svg";
import faissIcon from "../icons/generative_ai_tech_icons/faiss.svg";
import geminiIcon from "../icons/generative_ai_tech_icons/gemini.svg";
import gpt45Gpt4oIcon from "../icons/generative_ai_tech_icons/gpt-4-5-gpt-4o.svg";
import kerasIcon from "../icons/generative_ai_tech_icons/keras.svg";
import langChainIcon from "../icons/generative_ai_tech_icons/lang-chain.svg";
import llamaIndexIcon from "../icons/generative_ai_tech_icons/llama-index.svg";
import llamaIcon from "../icons/generative_ai_tech_icons/llama.svg";
import memoryReasoningChainsIcon from "../icons/generative_ai_tech_icons/memory-reasoning-chains.svg";
import mistralIcon from "../icons/generative_ai_tech_icons/mistral.svg";
import opensearchIcon from "../icons/generative_ai_tech_icons/opensearch.svg";
import pineconeIcon from "../icons/generative_ai_tech_icons/pinecone.svg";
import qdrantIcon from "../icons/generative_ai_tech_icons/qdrant.svg";
import toolCallingIcon from "../icons/generative_ai_tech_icons/tool-calling.svg";
import weaviateIcon from "../icons/generative_ai_tech_icons/weaviate.svg";
import earlyUserFeedbackLoopsIcon from "../icons/mvp_tech_icons/early-user-feedback-loops.svg";
import expressJsIcon from "../icons/mvp_tech_icons/express-js.svg";
import featurePrioritizationIcon from "../icons/mvp_tech_icons/feature-prioritization.svg";
import flutterIcon from "../icons/mvp_tech_icons/flutter.svg";
import githubIcon from "../icons/mvp_tech_icons/github.svg";
import iterativeReleasesIcon from "../icons/mvp_tech_icons/Iterative-releases.svg";
import mongodbIcon from "../icons/mvp_tech_icons/mongodb.svg";
import mvpDeliveryIcon from "../icons/mvp_tech_icons/mvp-delivery.svg";
import nestjsIcon from "../icons/mvp_tech_icons/nestjs.svg";
import nextJsIcon from "../icons/mvp_tech_icons/next-js.svg";
import postgresqlIcon from "../icons/mvp_tech_icons/postgresql.svg";
import rapidPrototypingIcon from "../icons/mvp_tech_icons/rapid-prototyping.svg";
import rasaIcon from "../icons/mvp_tech_icons/rasa.svg";
import reactJsIcon from "../icons/mvp_tech_icons/react-js.svg";
import reactNativeIcon from "../icons/mvp_tech_icons/react-native.svg";
import dotNetCoreIcon from "../icons/enterprise_app-tech_icons/.net-core.svg";
import erpCrmIntegrationIcon from "../icons/enterprise_app-tech_icons/erp-crm-integration.svg";
import javaIcon from "../icons/enterprise_app-tech_icons/java.svg";
import kubernetesIcon from "../icons/enterprise_app-tech_icons/kubernetes.svg";
import legacySystemConnectivityIcon from "../icons/enterprise_app-tech_icons/legacy-system-connectivity.svg";
import mysqlIcon from "../icons/enterprise_app-tech_icons/mysql.svg";
import restApisIcon from "../icons/enterprise_app-tech_icons/rest-apis.svg";
import thirdPartySystemIntegrationIcon from "../icons/enterprise_app-tech_icons/third-party-system-integration.svg";
import mvpDevelopment from "../icons/startup_app_tech_icons/mvp-development.svg";
import rapidPrototyping from "../icons/startup_app_tech_icons/rapid-prototyping.svg";
import costOptimizedArchitecture from "../icons/startup_app_tech_icons/cost-optimized-architecture.svg";
import scaleReadyDesign from "../icons/startup_app_tech_icons/scale-ready-design.svg";
import IterativeReleases from "../icons/startup_app_tech_icons/iterative_releases.svg";
import NFT_Music_Marketplace_Development from "../icons/our_services_icons/NFT_Music_Marketplace_Development.svg";
import automotive from "../icons/cross_platform_app_development_icons/automotive.svg";
import industryFitness from "../icons/cross_platform_app_development_icons/fitness.svg";
import industrySports from "../icons/cross_platform_app_development_icons/sports.svg";

export const Icons = {
  framework: `${ICON_BASE_URL}/assets/icons/framework.svg`,
  database: `${ICON_BASE_URL}/assets/icons/database.svg`,
  UpdatedServicesIcon: {
    showcaseIcon1: `${ICON_BASE_URL}/assets/icons/new-case-study-1.svg`,
    showcaseIcon2: `${ICON_BASE_URL}/assets/icons/new-case-study-2.svg`,
    showcaseIcon3: `${ICON_BASE_URL}/assets/icons/new-case-study-3.svg`,
  },
  technologyIcon: {
    mvpDevelopment: mvpDevelopment,
    rapidPrototyping: rapidPrototyping,
    costOptimizedArchitecture: costOptimizedArchitecture,
    scaleReadyDesign: scaleReadyDesign,
    IterativeReleases: IterativeReleases,
    fastApiIcon: fastApiIcon,
    spacyIcon: spacyIcon,
    amazonLexIcon: amazonLexIcon,
    angularIcon: angularIcon,
    awsIcon: awsIcon,
    azureIcon: azureIcon,
    djangoIcon: djangoIcon,
    flaskIcon: flaskIcon,
    gcpIcon: gcpIcon,
    googleDialogflowIcon: googleDialogflowIcon,
    hallucinationControlIcon: hallucinationControlIcon,
    ibmWatsonAssistantIcon: ibmWatsonAssistantIcon,
    llmsIcon: llmsIcon,
    microsoftBotFrameworkIcon: microsoftBotFrameworkIcon,
    microsoftCognitiveToolkitIcon: microsoftCognitiveToolkitIcon,
    multiChannelBotsIcon: multiChannelBotsIcon,
    nodeJsIcon: nodeJsIcon,
    promptEngineeringIcon: promptEngineeringIcon,
    pythonIcon: pythonIcon,
    pytorchIcon: pytorchIcon,
    ragIcon: ragIcon,
    reactIcon: reactIcon,
    rubyIcon: rubyIcon,
    tensorflowIcon: tensorflowIcon,
    vectorDatabasesIcon: vectorDatabasesIcon,
    vuejsIcon: vuejsIcon,
    aFrameIcon: aFrameIcon,
    babylonjsIcon: babylonjsIcon,
    cPlusPlusIcon: cPlusPlusIcon,
    cSharpIcon: cSharpIcon,
    firebaseIcon: firebaseIcon,
    godotIcon: godotIcon,
    javascriptIcon: javascriptIcon,
    metaQuestDkIcon: metaQuestDkIcon,
    openxrIcon: openxrIcon,
    react360Icon: react360Icon,
    steamvrIcon: steamvrIcon,
    threeJsIcon: threeJsIcon,
    unityIcon: unityIcon,
    unrealEngineIcon: unrealEngineIcon,

    arcoreIcon: arcoreIcon,
    arkitIcon: arkitIcon,
    artoolkitIcon: artoolkitIcon,
    googleCloudIcon: googleCloudIcon,
    kotlinIcon: kotlinIcon,
    maxstIcon: maxstIcon,
    swiftIcon: swiftIcon,
    vueJsIcon: vueJsIcon,
    vuforiaIcon: vuforiaIcon,
    webarIcon: webarIcon,
    wikitudeIcon: wikitudeIcon,

    agentWorkflowsIcon: agentWorkflowsIcon,
    claudeIcon: claudeIcon,
    dockerIcon: dockerIcon,
    faissIcon: faissIcon,
    geminiIcon: geminiIcon,
    gpt45Gpt4oIcon: gpt45Gpt4oIcon,
    kerasIcon: kerasIcon,
    langChainIcon: langChainIcon,
    expressJs: expressJsIcon,
    nextJs: nextJsIcon,
    jetpackCompose: `${ICON_BASE_URL}/assets/jetpack-compose.svg`,
    swiftUi: `${ICON_BASE_URL}/assets/swift-ui.svg`,
    bigCommerce: `${ICON_BASE_URL}/assets/big-commerce.svg`,
    contentful: `${ICON_BASE_URL}/assets/contentful.svg`,
    fireStore: `${ICON_BASE_URL}/assets/fire-store.svg`,
    dynamoDb: `${ICON_BASE_URL}/assets/dynamo-db.svg`,
    expo: `${ICON_BASE_URL}/assets/expo.svg`,
    framer: `${ICON_BASE_URL}/assets/framer.svg`,
    aiDesignTools: `${ICON_BASE_URL}/assets/ai-design-tools.svg`,
    canva: `${ICON_BASE_URL}/assets/canva.svg`,
    principle: `${ICON_BASE_URL}/assets/principle.svg`,
    svelte: `${ICON_BASE_URL}/assets/svelte.svg`,
    fastApi: `${ICON_BASE_URL}/assets/fast-api.svg`,
    goFiber: `${ICON_BASE_URL}/assets/go-fiber.svg`,
    bunJs: `${ICON_BASE_URL}/assets/bun-js.svg`,
    solana: `${ICON_BASE_URL}/assets/solana.svg`,
    polygon: `${ICON_BASE_URL}/assets/polygon.svg`,
    drupal: `${ICON_BASE_URL}/assets/drupal.svg`,
    ghost: `${ICON_BASE_URL}/assets/ghost.svg`,
    directus: `${ICON_BASE_URL}/assets/directus.svg`,
    zeplin: `${ICON_BASE_URL}/assets/zeplin.svg`,
    lucidChart: `${ICON_BASE_URL}/assets/lucid-chart.svg`,
    playwright: `${ICON_BASE_URL}/assets/playwright.svg`,
    cypress: `${ICON_BASE_URL}/assets/cypress.svg`,
    karateDsl: `${ICON_BASE_URL}/assets/karate-dsl.svg`,
    supertest: `${ICON_BASE_URL}/assets/supertest.svg`,
    newman: `${ICON_BASE_URL}/assets/newman.svg`,
    insomania: `${ICON_BASE_URL}/assets/insomania.svg`,
    k6: `${ICON_BASE_URL}/assets/k6.svg`,
    gatling: `${ICON_BASE_URL}/assets/gatling.svg`,
    appium: `${ICON_BASE_URL}/assets/appium.svg`,
    detox: `${ICON_BASE_URL}/assets/detox.svg`,
    owaspZap: `${ICON_BASE_URL}/assets/owasp-zap.svg`,
    burpSuite: `${ICON_BASE_URL}/assets/burp-suite.svg`,
    binanceSmartChain: `${ICON_BASE_URL}/assets/binance-smart-chain.svg`,
    oracleCloud: `${ICON_BASE_URL}/assets/oracle-cloud.svg`,
    autoScaling: `${ICON_BASE_URL}/assets/auto-scaling.svg`,
    serverless: `${ICON_BASE_URL}/assets/serverless.svg`,
    disasterRecovery: `${ICON_BASE_URL}/assets/disaster-recovery.svg`,
    zeroTrustRecovery: `${ICON_BASE_URL}/assets/zero-trust-recovery.svg`,
    finOps: `${ICON_BASE_URL}/assets/fin-ops.svg`,
    terraform: `${ICON_BASE_URL}/assets/terraform.svg`,
    huggingFace: `${ICON_BASE_URL}/assets/hugging-face.svg`,
    cursor: `${ICON_BASE_URL}/assets/cursor.svg`,
    crewAi: `${ICON_BASE_URL}/assets/crew-ai.svg`,
    autogen: `${ICON_BASE_URL}/assets/autogen.svg`,
    googleColab: `${ICON_BASE_URL}/assets/google-colab.svg`,
    jupyter: `${ICON_BASE_URL}/assets/jupyter.svg`,
    googleBigQuery: `${ICON_BASE_URL}/assets/google-big-query.svg`,
    awsS3: `${ICON_BASE_URL}/assets/aws-s3.svg`,
    snowflake: `${ICON_BASE_URL}/assets/snowflake.svg`,
    databricks: `${ICON_BASE_URL}/assets/databricks.svg`,
    mlFlow: `${ICON_BASE_URL}/assets/ml-flow.svg`,
    rayServe: `${ICON_BASE_URL}/assets/ray-serve.svg`,
    langChain: `${ICON_BASE_URL}/assets/langchain.svg`,
    copilotStudio: `${ICON_BASE_URL}/assets/copilot-studio.svg`,
    langGraph: `${ICON_BASE_URL}/assets/lang-graph.svg`,
    milvus: `${ICON_BASE_URL}/assets/milvus.svg`,
    chroma: `${ICON_BASE_URL}/assets/chroma.svg`,
    n8n: `${ICON_BASE_URL}/assets/n8n.svg`,
    autoGpt: `${ICON_BASE_URL}/assets/auto-gpt.svg`,
    flowise: `${ICON_BASE_URL}/assets/flowise.svg`,
    anthropic: `${ICON_BASE_URL}/assets/anthropic.svg`,
    replit: `${ICON_BASE_URL}/assets/replit.svg`,
    tailwindCss: `${ICON_BASE_URL}/assets/tailwind-css.svg`,
    salesforceEinstein: `${ICON_BASE_URL}/assets/salesforce-einstein.svg`,
    opencv: `${ICON_BASE_URL}/assets/opencv.svg`,
    yolo: `${ICON_BASE_URL}/assets/yolo.svg`,
    mediaPipe: `${ICON_BASE_URL}/assets/media-pipe.svg`,
    detectron2: `${ICON_BASE_URL}/assets/Detectron2.svg`,
    simpleCv: `${ICON_BASE_URL}/assets/simple-cv.svg`,
    onnxRuntime: `${ICON_BASE_URL}/assets/onnx-runtime.svg`,
    cuda: `${ICON_BASE_URL}/assets/cuda.svg`,
    googleVisionAi: `${ICON_BASE_URL}/assets/google-vision-ai.svg`,
    azureComputerVision: `${ICON_BASE_URL}/assets/azure-computer-vision.svg`,
    nvidiaTriton: `${ICON_BASE_URL}/assets/nvidia-triton.svg`,
    objectDetection: `${ICON_BASE_URL}/assets/object-detection.svg`,
    facialRecognition: `${ICON_BASE_URL}/assets/facial-recognition.svg`,
    imageSegmentation: `${ICON_BASE_URL}/assets/image-segmentation.svg`,
    videoAnalytics: `${ICON_BASE_URL}/assets/video-analytics.svg`,
    qualityInspection: `${ICON_BASE_URL}/assets/quality-inspection.svg`,
    gdScript: `${ICON_BASE_URL}/assets/gd-script.svg`,
    webXr: `${ICON_BASE_URL}/assets/web-xr.svg`,
    langChainTechIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/lang-chain-tech.svg`,
    awsS3Icon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-s3-icon.svg`,
    cdnAssetIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/cdn-asset-icon.svg`,
    restApiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/rest-api-icon.svg`,
    kafkaIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/kafka-icon.svg`,
    ebayApiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ebay-api-icon.svg`,
    amazonPrdouctIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/amazon-product-api.svg`,
    secureTokenIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/secure-token-icon.svg`,
    backgroundJobIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/background-job-icon.svg`,
    deepSeekIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/deep-seek-icon.svg`,
    recruitWorkflowIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/recruit-workflow-icon.svg`,
    aiCandidateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-candidate-icon.svg`,
    semanticSearchIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/semantic-search-icon.svg`,
    convIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/conv-ai-icon.svg`,
    stripeIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/stripe-icon.svg`,
    ciCdIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ci-cd-icon.svg`,
    twilioIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/twilio-icon.svg`,
    rocketReachIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/rocket-reach-icon.svg`,
    mariaDbIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/maria-db-icon.svg`,
    otpAuthIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/otp-auth-icon.svg`,
    apiSecurityIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/api-security-icon.svg`,
    roleBasedIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/role-based-icon.svg`,
    awsEc2Icon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-ec2-icon.svg`,
    awsRdsIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-rds-icon.svg`,
    awsCloudFrontIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-cloudfront-icon.svg`,
    aiSeoIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-seo-icon.svg`,
    promptIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/prompt-icon.svg`,
    automatedInsightIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/automated-insight-icon.svg`,
    pandasIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/pandas-icon.svg`,
    whatsappBusinessIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/whatsapp-business-icon.svg`,
    typescriptIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/typescript-icon.svg`,
    rechartsIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/recharts-icon.svg`,
    grokIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/grok-icon.svg`,
    openAiImageIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/open-ai-image-icon.svg`,
    stabilityAiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/stability-ai-icon.svg`,
    semanticVectorIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/semantic-vector-icon.svg`,
    ragTechIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/rag-icon.svg`,
    llamaIndexIcon: llamaIndexIcon,
    llamaIcon: llamaIcon,
    memoryReasoningChainsIcon: memoryReasoningChainsIcon,
    mistralIcon: mistralIcon,
    opensearchIcon: opensearchIcon,
    pineconeIcon: pineconeIcon,
    qdrantIcon: qdrantIcon,
    toolCallingIcon: toolCallingIcon,
    weaviateIcon: weaviateIcon,

    earlyUserFeedbackLoopsIcon: earlyUserFeedbackLoopsIcon,
    expressJsIcon: expressJsIcon,
    featurePrioritizationIcon: featurePrioritizationIcon,
    flutterIcon: flutterIcon,
    githubIcon: githubIcon,
    iterativeReleasesIcon: iterativeReleasesIcon, // No Update With CDN Server File Name ISSSUE
    mongodbIcon: mongodbIcon,
    mvpDeliveryIcon: mvpDeliveryIcon,
    nestjsIcon: nestjsIcon,
    nextJsIcon: nextJsIcon,
    postgresqlIcon: postgresqlIcon,
    rapidPrototypingIcon: rapidPrototypingIcon,
    rasaIcon: rasaIcon,
    reactJsIcon: reactJsIcon,
    reactNativeIcon: reactNativeIcon,
    dotNetCoreIcon: dotNetCoreIcon,
    erpCrmIntegrationIcon: erpCrmIntegrationIcon,
    javaIcon: javaIcon,
    kubernetesIcon: kubernetesIcon,
    legacySystemConnectivityIcon: legacySystemConnectivityIcon,
    mysqlIcon: mysqlIcon,
    restApisIcon: restApisIcon,
    thirdPartySystemIntegrationIcon: thirdPartySystemIntegrationIcon,

    ApiIntegrationStrategy: `${ICON_BASE_URL}/assets/icons/consulting_services/api-integration-strategy.svg`,
    ArchitectureReviewRecommendations: `${ICON_BASE_URL}/assets/icons/consulting_services/architecture-review-recommendations.svg`,
    Aws: `${ICON_BASE_URL}/assets/icons/Cloud/aws.svg`,
    Azure: `${ICON_BASE_URL}/assets/icons/consulting_services/azure.svg`,
    CloudMigrationPlanning: `${ICON_BASE_URL}/assets/icons/consulting_services/cloud-migration-planning.svg`,
    CloudReadinessAssessment: `${ICON_BASE_URL}/assets/icons/consulting_services/cloud-readiness-assessment.svg`,
    CostOptimizationStrategy: `${ICON_BASE_URL}/assets/icons/consulting_services/cost-optimization-strategy.svg`,
    Docker: `${ICON_BASE_URL}/assets/icons/Cloud/docker.svg`,
    GoogleCloud: `${ICON_BASE_URL}/assets/icons/consulting_services/google-cloud.svg`,
    Kubernetes: `${ICON_BASE_URL}/assets/icons/Cloud/kubernetes.svg`,
    LegacySystemModernization: `${ICON_BASE_URL}/assets/icons/consulting_services/legacy-system-modernization.svg`,
    Magento: `${ICON_BASE_URL}/assets/icons/consulting_services/magento.svg`,
    MonolithToMicroservicesStrategy: `${ICON_BASE_URL}/assets/icons/consulting_services/monolith-to-microservices-strategy.svg`,
    MultiTenantSaasArchitecture: `${ICON_BASE_URL}/assets/icons/consulting_services/multi-tenant-saas-architecture.svg`,
    OngoingCtoArchitectSupport: `${ICON_BASE_URL}/assets/icons/consulting_services/ongoing-cto-architect-support.svg`,
    ScalabilityPerformancePlanning: `${ICON_BASE_URL}/assets/icons/consulting_services/scalability-performance-planning.svg`,
    SecurityComplianceAdvisory: `${ICON_BASE_URL}/assets/icons/consulting_services/security-compliance-advisory.svg`,
    Shopify: `${ICON_BASE_URL}/assets/icons/consulting_services/shopify.svg`,
    ShortTermAdvisoryWeeks: `${ICON_BASE_URL}/assets/icons/consulting_services/short-term-advisory-weeks.svg`,
    SolutionArchitectureSystemDesign: `${ICON_BASE_URL}/assets/icons/consulting_services/solution-architecture-system-design.svg`,
    TechnicalDueDiligence: `${ICON_BASE_URL}/assets/icons/consulting_services/technical-due-diligence.svg`,
    TechnologyStackSelection: `${ICON_BASE_URL}/assets/icons/consulting_services/technology-stack-selection.svg`,
    Woocommerce: `${ICON_BASE_URL}/assets/icons/consulting_services/woocommerce.svg`,

    DotNetCore: `${ICON_BASE_URL}/assets/icons/Cloud/.net-core.svg`,
    Angular: `${ICON_BASE_URL}/assets/icons/NFT/angular.svg`,
    CiCdPipelines: `${ICON_BASE_URL}/assets/icons/Cloud/ci-cd-pipelines.svg`,
    GitBasedWorkflows: `${ICON_BASE_URL}/assets/icons/Cloud/git-based-workflows.svg`,
    GoogleCloudPlatform: `${ICON_BASE_URL}/assets/icons/Cloud/google-cloud-platform.svg`,
    Iaas: `${ICON_BASE_URL}/assets/icons/Cloud/iaas.svg`,
    Java: `${ICON_BASE_URL}/assets/icons/wearable_app/java.svg`,
    MicrosoftAzure: `${ICON_BASE_URL}/assets/icons/Cloud/microsoft-azure.svg`,
    Mongodb: `${ICON_BASE_URL}/assets/icons/progressive_web/mongodb.svg`,
    MonitoringLogging: `${ICON_BASE_URL}/assets/icons/Cloud/monitoring-logging.svg`,
    Mysql: `${ICON_BASE_URL}/assets/icons/progressive_web/mysql.svg`,
    Nodejs: `${ICON_BASE_URL}/assets/icons/NFT/nodejs.svg`,
    Paas: `${ICON_BASE_URL}/assets/icons/Cloud/paas.svg`,
    Postgresql: `${ICON_BASE_URL}/assets/icons/progressive_web/postgresql.svg`,
    Python: `${ICON_BASE_URL}/assets/icons/NFT/python.svg`,
    Reactjs: `${ICON_BASE_URL}/assets/icons/NFT/reactjs.svg`,
    Saas: `${ICON_BASE_URL}/assets/icons/Cloud/saas.svg`,
    Vuejs: `${ICON_BASE_URL}/assets/icons/NFT/vuejs.svg`,

    FiveGLte: `${ICON_BASE_URL}/assets/icons/IOT/5g-lte.svg`,
    Amqp: `${ICON_BASE_URL}/assets/icons/IOT/amqp.svg`,
    AwsIotCore: `${ICON_BASE_URL}/assets/icons/IOT/aws-iot-core.svg`,
    Ble: `${ICON_BASE_URL}/assets/icons/IOT/ble.svg`,
    Bluetooth: `${ICON_BASE_URL}/assets/icons/wearable_app/bluetooth.svg`,
    CloudSync: `${ICON_BASE_URL}/assets/icons/IOT/cloud-sync.svg`,
    Coap: `${ICON_BASE_URL}/assets/icons/IOT/coap.svg`,
    CustomGcpBasedIotArchitectures: `${ICON_BASE_URL}/assets/icons/IOT/custom-gcp-based-iot-architectures.svg`,
    Ethernet: `${ICON_BASE_URL}/assets/icons/IOT/ethernet.svg`,
    Flutter: `${ICON_BASE_URL}/assets/icons/technology_icon/Flutter.svg`,
    Golang: `${ICON_BASE_URL}/assets/icons/NFT/golang.svg`,
    GsmNetwork: `${ICON_BASE_URL}/assets/icons/IOT/gsm-network.svg`,
    Influxdb: `${ICON_BASE_URL}/assets/icons/IOT/influxdb.svg`,
    Kotlin: `${ICON_BASE_URL}/assets/icons/wearable_app/kotlin.svg`,
    MicrosoftAzureIotHub: `${ICON_BASE_URL}/assets/icons/IOT/microsoft-azure-iot-hub.svg`,
    Mqtt: `${ICON_BASE_URL}/assets/icons/wearable_app/mqtt.svg`,
    NodeJs: `${ICON_BASE_URL}/assets/icons/progressive_web/node-js.svg`,
    ReactNative: `${ICON_BASE_URL}/assets/icons/wearable_app/react-native.svg`,
    React: `${ICON_BASE_URL}/assets/icons/IOT/react.svg`,
    Sensors: `${ICON_BASE_URL}/assets/icons/IOT/sensors.svg`,
    Swift: `${ICON_BASE_URL}/assets/icons/wearable_app/swift.svg`,
    Timescaledb: `${ICON_BASE_URL}/assets/icons/IOT/timescaledb.svg`,
    Wireless: `${ICON_BASE_URL}/assets/icons/IOT/wireless.svg`,
    Xmpp: `${ICON_BASE_URL}/assets/icons/IOT/xmpp.svg`,

    AspNet: `${ICON_BASE_URL}/assets/icons/progressive_web/asp-net.svg`,
    Cassandra: `${ICON_BASE_URL}/assets/icons/progressive_web/cassandra.svg`,
    Mssql: `${ICON_BASE_URL}/assets/icons/progressive_web/mssql.svg`,
    Php: `${ICON_BASE_URL}/assets/icons/progressive_web/php.svg`,
    ReactJs: `${ICON_BASE_URL}/assets/icons/progressive_web/react-js.svg`,
    Svelte: `${ICON_BASE_URL}/assets/icons/progressive_web/svelte.svg`,

    AccessibilityInsights: `${ICON_BASE_URL}/assets/icons/web_design/accessibility-insights.svg`,
    AdobeIllustrator: `${ICON_BASE_URL}/assets/icons/web_design/adobe-illustrator.svg`,
    AdobePhotoshop: `${ICON_BASE_URL}/assets/icons/web_design/adobe-photoshop.svg`,
    AdobeXd: `${ICON_BASE_URL}/assets/icons/web_design/adobe-xd.svg`,
    Aeplin: `${ICON_BASE_URL}/assets/icons/web_design/aeplin.svg`,
    AfterEffect: `${ICON_BASE_URL}/assets/icons/web_design/after-effect.svg`,
    Avocode: `${ICON_BASE_URL}/assets/icons/web_design/avocode.svg`,
    AxeDevtools: `${ICON_BASE_URL}/assets/icons/web_design/axe-devtools.svg`,
    AxureRp: `${ICON_BASE_URL}/assets/icons/web_design/axure-rp.svg`,
    Balsamiq: `${ICON_BASE_URL}/assets/icons/web_design/balsamiq.svg`,
    CrazyEgg: `${ICON_BASE_URL}/assets/icons/web_design/crazy-egg.svg`,
    Figjam: `${ICON_BASE_URL}/assets/icons/web_design/figjam.svg`,
    FigmaDevMod: `${ICON_BASE_URL}/assets/icons/web_design/figma-dev-mod.svg`,
    Figma: `${ICON_BASE_URL}/assets/icons/figma.svg`,
    Framer: `${ICON_BASE_URL}/assets/icons/web_design/framer.svg`,
    GoogleLighthouse: `${ICON_BASE_URL}/assets/icons/web_design/google-lighthouse.svg`,
    Hotjar: `${ICON_BASE_URL}/assets/icons/web_design/hotjar.svg`,
    Invision: `${ICON_BASE_URL}/assets/icons/web_design/invision.svg`,
    Lookback: `${ICON_BASE_URL}/assets/icons/web_design/lookback.svg`,
    Marvel: `${ICON_BASE_URL}/assets/icons/web_design/marvel.svg`,
    Maze: `${ICON_BASE_URL}/assets/icons/web_design/maze.svg`,
    Miro: `${ICON_BASE_URL}/assets/icons/web_design/miro.svg`,
    OptimalWorkshop: `${ICON_BASE_URL}/assets/icons/web_design/optimal-workshop.svg`,
    Sketch: `${ICON_BASE_URL}/assets/icons/web_design/sketch.svg`,
    Stark: `${ICON_BASE_URL}/assets/icons/web_design/stark.svg`,
    Ucidchart: `${ICON_BASE_URL}/assets/icons/web_design/ucidchart.svg`,
    Usabilityhub: `${ICON_BASE_URL}/assets/icons/web_design/usabilityhub.svg`,
    Usertesting: `${ICON_BASE_URL}/assets/icons/web_design/usertesting.svg`,
    Wave: `${ICON_BASE_URL}/assets/icons/web_design/wave.svg`,
    Whimsical: `${ICON_BASE_URL}/assets/icons/web_design/whimsical.svg`,

    Ethereum: `${ICON_BASE_URL}/assets/icons/NFT/ethereum.svg`,
    Expressjs: `${ICON_BASE_URL}/assets/icons/NFT/expressjs.svg`,
    Nestjs: `${ICON_BASE_URL}/assets/icons/NFT/nestjs.svg`,
    Nextjs: `${ICON_BASE_URL}/assets/icons/NFT/nextjs.svg`,
    Rust: `${ICON_BASE_URL}/assets/icons/NFT/rust.svg`,
    Solidity: `${ICON_BASE_URL}/assets/icons/NFT/solidity.svg`,
    Vyper: `${ICON_BASE_URL}/assets/icons/NFT/vyper.svg`,
    Web3js: `${ICON_BASE_URL}/assets/icons/NFT/web3js.svg`,

    AppleHealthkit: `${ICON_BASE_URL}/assets/icons/wearable_app/apple-healthkit.svg`,
    AppleMapkit: `${ICON_BASE_URL}/assets/icons/wearable_app/apple-mapkit.svg`,
    AppleWatch: `${ICON_BASE_URL}/assets/icons/wearable_app/apple-watch.svg`,
    Cpp: `${ICON_BASE_URL}/assets/icons/wearable_app/c++.svg`,
    Fitbit: `${ICON_BASE_URL}/assets/icons/wearable_app/fitbit.svg`,
    Garmin: `${ICON_BASE_URL}/assets/icons/wearable_app/garmin.svg`,
    GoogleFitApi: `${ICON_BASE_URL}/assets/icons/wearable_app/google-fit-api.svg`,
    GoogleMapsPlatform: `${ICON_BASE_URL}/assets/icons/wearable_app/google-maps-platform.svg`,
    Nfc: `${ICON_BASE_URL}/assets/icons/wearable_app/nfc.svg`,
    ObjectiveC: `${ICON_BASE_URL}/assets/icons/wearable_app/objective-c.svg`,
    SamsungGalaxyWatch: `${ICON_BASE_URL}/assets/icons/wearable_app/samsung-galaxy-watch.svg`,
    SamsungHealthSdk: `${ICON_BASE_URL}/assets/icons/wearable_app/samsung-health-sdk.svg`,
    Watchkit: `${ICON_BASE_URL}/assets/icons/wearable_app/watchkit.svg`,
    WearOs: `${ICON_BASE_URL}/assets/icons/wearable_app/wear-os.svg`,

    ApacheJmeter: `${ICON_BASE_URL}/assets/icons/quality_assurance/apache-jmeter.svg`,
    Postman: `${ICON_BASE_URL}/assets/icons/quality_assurance/postman.svg`,
    RestAssured: `${ICON_BASE_URL}/assets/icons/quality_assurance/rest-assured.svg`,
    SeleniumWebdriver: `${ICON_BASE_URL}/assets/icons/quality_assurance/selenium-webdriver.svg`,
    AI: `${ICON_BASE_URL}/assets/icons/technology_icon/AI.svg`,
    android: `${ICON_BASE_URL}/assets/icons/technology_icon/Android.svg`,
    Apple_Watch: `${ICON_BASE_URL}/assets/icons/technology_icon/Apple_Watch.svg`,
    BLE_Device_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/BLE_Device_Integration.svg`,
    Bootstrap: `${ICON_BASE_URL}/assets/icons/technology_icon/Bootstrap.svg`,
    Cakephp: `${ICON_BASE_URL}/assets/icons/technology_icon/Cakephp.svg`,
    codeigniter: `${ICON_BASE_URL}/assets/icons/technology_icon/Codeigniter.svg`,
    cross_Platform_App_Development_white: `${ICON_BASE_URL}/assets/icons/technology_icon/Cross_Platform_App_Development_white.svg`,
    crossPlatform: `${ICON_BASE_URL}/assets/icons/technology_icon/cross_Platform.svg`,
    Dagger: `${ICON_BASE_URL}/assets/icons/technology_icon/Dagger.svg`,
    Django: `${ICON_BASE_URL}/assets/icons/technology_icon/Django.svg`,
    DotNet: `${ICON_BASE_URL}/assets/icons/technology_icon/dot-net.svg`,
    ExpressJS: `${ICON_BASE_URL}/assets/icons/technology_icon/ExpressJS.svg`,
    Firebase: `${ICON_BASE_URL}/assets/icons/technology_icon/Firebase.svg`,
    Flask: `${ICON_BASE_URL}/assets/icons/technology_icon/Flask.svg`,
    flutter: `${ICON_BASE_URL}/assets/icons/technology_icon/Flutter.svg`,
    flutterWhite: `${ICON_BASE_URL}/assets/icons/technology_icon/flutter_White.svg`,
    Full_Stack: `${ICON_BASE_URL}/assets/icons/technology_icon/Full_Stack.svg`,
    Glide: `${ICON_BASE_URL}/assets/icons/technology_icon/Glide.svg`,
    IOS: `${ICON_BASE_URL}/assets/icons/technology_icon/IOS.svg`,
    JAVA: `${ICON_BASE_URL}/assets/icons/technology_icon/Java.svg`,
    Joomla: `${ICON_BASE_URL}/assets/icons/technology_icon/Joomla.svg`,
    Laravel: `${ICON_BASE_URL}/assets/icons/technology_icon/Laravel.svg`,
    Lottie: `${ICON_BASE_URL}/assets/icons/technology_icon/Lottie.svg`,
    magento: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento.svg`,
    mariadb: `${ICON_BASE_URL}/assets/icons/technology_icon/mariadb.svg`,
    MeanStack: `${ICON_BASE_URL}/assets/icons/technology_icon/MeanStack.svg`,
    MernStack: `${ICON_BASE_URL}/assets/icons/technology_icon/MernStack.svg`,
    microsoftsqlserver: `${ICON_BASE_URL}/assets/icons/technology_icon/microsoftsqlserver.svg`,
    ML: `${ICON_BASE_URL}/assets/icons/technology_icon/ML.svg`,
    MongoDB: `${ICON_BASE_URL}/assets/icons/technology_icon/MongoDB.svg`,
    MySql: `${ICON_BASE_URL}/assets/icons/technology_icon/MySql.svg`,
    NextJs: `${ICON_BASE_URL}/assets/icons/technology_icon/NextJs.svg`,
    php: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/php-tech.svg`,
    Photoshop: `${ICON_BASE_URL}/assets/icons/technology_icon/Photoshop.svg`,
    PostgreSql: `${ICON_BASE_URL}/assets/icons/technology_icon/PostSql.svg`,
    Realm: `${ICON_BASE_URL}/assets/icons/technology_icon/Realm.svg`,
    Redis: `${ICON_BASE_URL}/assets/icons/technology_icon/redis.svg`,
    Retrofit: `${ICON_BASE_URL}/assets/icons/technology_icon/Retrofit.svg`,
    Ruby: `${ICON_BASE_URL}/assets/icons/technology_icon/Ruby.svg`,
    Scalability: `${ICON_BASE_URL}/assets/icons/technology_icon/Scalability.svg`,
    Spring_Boot: `${ICON_BASE_URL}/assets/icons/technology_icon/Spring_Boot.svg`,
    SQLite: `${ICON_BASE_URL}/assets/icons/technology_icon/SQLite.svg`,
    Stetho: `${ICON_BASE_URL}/assets/icons/technology_icon/Stetho.svg`,
    Strapi: `${ICON_BASE_URL}/assets/icons/technology_icon/Strapi.svg`,
    Symfony: `${ICON_BASE_URL}/assets/icons/technology_icon/Symfony.svg`,
    Threejs: `${ICON_BASE_URL}/assets/icons/technology_icon/threejs.svg`,
    VueJS: `${ICON_BASE_URL}/assets/icons/technology_icon/Vue_JS.svg`,
    WearOS: `${ICON_BASE_URL}/assets/icons/technology_icon/WearOS.svg`,
    WebRTC: `${ICON_BASE_URL}/assets/icons/technology_icon/WebRTC.svg`,
    WooCommerce: `${ICON_BASE_URL}/assets/icons/technology_icon/WooCommerce.svg`,
    WordPress: `${ICON_BASE_URL}/assets/icons/technology_icon/WordPress.svg`,
    Yii: `${ICON_BASE_URL}/assets/icons/technology_icon/Yii.svg`,
    Zend: `${ICON_BASE_URL}/assets/icons/technology_icon/Zend.svg`,
    Zxing: `${ICON_BASE_URL}/assets/icons/technology_icon/Zxing.svg`,
    Ionic: `${ICON_BASE_URL}/assets/icons/technology_icon/ionic.svg`,
    TensorFlow: `${ICON_BASE_URL}/assets/icons/technology_icon/TensorFlow.svg`,
    CPLUS: `${ICON_BASE_URL}/assets/icons/technology_icon/CPLUS.svg`,
    NodeJS_2: `${ICON_BASE_URL}/assets/icons/technology_icon/NodeJS_2.svg`,
    Django_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Django_2.svg`,
    RASA: `${ICON_BASE_URL}/assets/icons/technology_icon/RASA.svg`,
    Flask_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Flask_2.svg`,
    PyTorch: `${ICON_BASE_URL}/assets/icons/technology_icon/PyTorch.svg`,
    Microsoft_Azure: `${ICON_BASE_URL}/assets/icons/technology_icon/Microsoft_Azure.svg`,

    Corda: `${ICON_BASE_URL}/assets/icons/technology_icon/Corda.svg`,
    EOSIO: `${ICON_BASE_URL}/assets/icons/technology_icon/EOSIO.svg`,
    Hyperledger_Sawtooth: `${ICON_BASE_URL}/assets/icons/technology_icon/Hyperledger_Sawtooth.svg`,
    Hyperlegder_Fabric: `${ICON_BASE_URL}/assets/icons/technology_icon/Hyperlegder_Fabric.svg`,
    Quorum: `${ICON_BASE_URL}/assets/icons/technology_icon/Quorum.svg`,

    Commerce_Order_Management_Magento: `${ICON_BASE_URL}/assets/icons/technology_icon/Commerce_Order_Management_Magento.svg`,
    CRM_ERP_PIM_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/CRM_ERP_PIM_Integration.svg`,
    Magento_1_to_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_1_to_2.svg`,
    Magento_Enterprise: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Enterprise.svg`,
    Magento_Plugin_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Plugin_Customization.svg`,
    Magento_Responsive_Design: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Responsive_Design.svg`,
    Magento_Theme_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Theme_Integration.svg`,
    Magento2: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento2.svg`,
    Migration_to_Magento: `${ICON_BASE_URL}/assets/icons/technology_icon/Migration_to_Magento.svg`,
    Module_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/Module_Customization.svg`,
    PSD_to_Magento_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/PSD_to_Magento_Customization.svg`,
    API_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/API_Development.svg`,
    CMS_Solution_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/CMS_Solution_Integration.svg`,
    Conversion_Optimization: `${ICON_BASE_URL}/assets/icons/technology_icon/Conversion_Optimization.svg`,
    Custom_Page_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Custom_Page_Development.svg`,
    Migration_to_Shopify: `${ICON_BASE_URL}/assets/icons/technology_icon/Migration_to_Shopify.svg`,
    Mobile_Commerce: `${ICON_BASE_URL}/assets/icons/technology_icon/Mobile_Commerce.svg`,
    Multi_lingual_Setup: `${ICON_BASE_URL}/assets/icons/technology_icon/Multi_lingual_Setup.svg`,
    Online_Shopping_Cart_Management: `${ICON_BASE_URL}/assets/icons/technology_icon/Online_Shopping_Cart_Management.svg`,
    Payment_Gateway_ntegration: `${ICON_BASE_URL}/assets/icons/technology_icon/Payment_Gateway_ntegration.svg`,
    Shopify_Point_of_Sale: `${ICON_BASE_URL}/assets/icons/technology_icon/Shopify_Point_of_Sale.svg`,
    Theme_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/Theme_Customization.svg`,
    shopify_icon: `${ICON_BASE_URL}/assets/icons/technology_icon/shopify_icon.svg`,
    WooCommerce_Plugin_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/WooCommerce_Plugin_Customization.svg`,
    Complete_WooCommerce_WordPress_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Complete_WooCommerce_WordPress_Development.svg`,
    Omni_channel_Planning: `${ICON_BASE_URL}/assets/icons/technology_icon/Omni_channel_Planning.svg`,
    WooCommerce_Theme_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/WooCommerce_Theme_Customization.svg`,
    Comprehensive_Order_Management: `${ICON_BASE_URL}/assets/icons/technology_icon/Comprehensive_Order_Management.svg`,
    Customized_eCommerce_Site_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Customized_eCommerce_Site_Development.svg`,
    Desired_Payment_Gateway_Options: `${ICON_BASE_URL}/assets/icons/technology_icon/Desired_Payment_Gateway_Options.svg`,
    Third_Party_Integrations: `${ICON_BASE_URL}/assets/icons/technology_icon/Third_Party_Integrations.svg`,
    Personalized_Storefront: `${ICON_BASE_URL}/assets/icons/technology_icon/Personalized_Storefront.svg`,
    Scalable_Application: `${ICON_BASE_URL}/assets/icons/technology_icon/Scalable_Application.svg`,
    Mobile_Commerce_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Mobile_Commerce_2.svg`,
    Conversion_Optimization_new: `${ICON_BASE_URL}/assets/icons/technology_icon/Conversion_Optimization_new.svg`,

    //Open Source Page Images
    Open_Source_Sof_ware_Consulting: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_Sof_ware_Consulting.svg`,
    Open_Source_CRM_ntegrations: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_CRM_ntegrations.svg`,
    Custom_Open_Source_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Custom_Open_Source_Development.svg`,
    Open_Source_Database_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_Database_Development.svg`,
    Open_Source_ERP_Solutions: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_ERP_Solutions.svg`,
    Open_Source_eCommerce_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_eCommerce_Development.svg`,
    Open_Source_CRM_Solutions: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_CRM_Solutions.svg`,
    Cost_Efficiency: `${ICON_BASE_URL}/assets/icons/technology_icon/Cost_Efficiency.svg`,
    Community_Support: `${ICON_BASE_URL}/assets/icons/technology_icon/Community_Support.svg`,
    Enhanced_Transparency: `${ICON_BASE_URL}/assets/icons/technology_icon/Enhanced_Transparency.svg`,
    Avoiding_Vendor_Lock: `${ICON_BASE_URL}/assets/icons/technology_icon/Avoiding_Vendor_Lock.svg`,
    Competitive_Advantage: `${ICON_BASE_URL}/assets/icons/technology_icon/Competitive_Advantage.svg`,
    Expert_Developers: `${ICON_BASE_URL}/assets/icons/technology_icon/Expert_Developers.svg`,
    Flexible_Systems: `${ICON_BASE_URL}/assets/icons/technology_icon/Flexible_Systems.svg`,
    High_Quality_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/High_Quality_Development.svg`,
    Seamless_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/Seamless_Integration.svg`,
    Security_Reliability_Focus: `${ICON_BASE_URL}/assets/icons/technology_icon/Security_Reliability_Focus.svg`,
    Tailored_Solutions: `${ICON_BASE_URL}/assets/icons/technology_icon/Tailored_Solutions.svg`,
  },
  dot: `${ICON_BASE_URL}/assets/icons/dot.webp`,
  timer1: `${ICON_BASE_URL}/assets/icons/timer1.svg`,
  stopwatch1: `${ICON_BASE_URL}/assets/icons/stopwatch1.svg`,
  runtime1: `${ICON_BASE_URL}/assets/icons/runtime1.svg`,
  fixedprice1: `${ICON_BASE_URL}/assets/icons/fixedprice1.svg`,
  clock1: `${ICON_BASE_URL}/assets/icons/clock1.svg`,
  arrowLeft: `${ICON_BASE_URL}/assets/icons/arrow-left.svg`,
  arrowUp: `${ICON_BASE_URL}/assets/icons/arrow-up.svg`,
  chevron: `${ICON_BASE_URL}/assets/icons/chevron.svg`,
  chevronBlue: `${ICON_BASE_URL}/assets/icons/chevron-blue.svg`,
  chevronDown: `${ICON_BASE_URL}/assets/icons/chevron-down.svg`,
  chevronDownDark: `${ICON_BASE_URL}/assets/icons/chevron-down-dark.svg`,
  chevronWhiteLeft: `${ICON_BASE_URL}/assets/icons/chevron-white-left.svg`,
  quote: `${ICON_BASE_URL}/assets/icons/quote.svg`,
  industryArrow: `${ICON_BASE_URL}/assets/icons/industry-arrow.svg`,
  slideLeft: `${ICON_BASE_URL}/assets/icons/slide-left.svg`,
  slideRight: `${ICON_BASE_URL}/assets/icons/slide-right.svg`,
  slideLeftWhite: `${ICON_BASE_URL}/assets/icons/slide-left-white.svg`,
  slideRightWhite: `${ICON_BASE_URL}/assets/icons/slide-right-white.svg`,
  cursorDrag: `${ICON_BASE_URL}/assets/icons/cursor-drag.webp`,
  mailIcon: `${ICON_BASE_URL}/assets/icons/mail.svg`,
  skypeIcon: `${ICON_BASE_URL}/assets/icons/skype-icon.svg`,
  teams: `${ICON_BASE_URL}/assets/icons/teams.svg`,
  navMenuArrow: `${ICON_BASE_URL}/assets/icons/nav-menu-arrow.svg`,
  security: `${ICON_BASE_URL}/assets/icons/security.svg`,
  facebook: `${ICON_BASE_URL}/assets/icons/facebook.svg`,
  linkedin: `${ICON_BASE_URL}/assets/icons/linkedin.svg`,
  dribbble: `${ICON_BASE_URL}/assets/icons/dribbble.svg`,
  behance: `${ICON_BASE_URL}/assets/icons/behance.svg`,
  instagram: `${ICON_BASE_URL}/assets/icons/instagram.svg`,
  x: `${ICON_BASE_URL}/assets/icons/x.svg`,
  uploadPlus: `${ICON_BASE_URL}/assets/icons/upload_plus.svg`,
  DotNet: `${ICON_BASE_URL}/assets/icons/technology_icon/dot-net.svg`,
  MongoDB: `${ICON_BASE_URL}/assets/icons/technology_icon/MongoDB.svg`,
  MySql: `${ICON_BASE_URL}/assets/icons/technology_icon/MySql.svg`,
  NodeJS: `${ICON_BASE_URL}/assets/icons/technology_icon/Node_JS.svg`,
  PHP: `${ICON_BASE_URL}/assets/icons/technology_icon/PHP.svg`,
  PostgreSql: `${ICON_BASE_URL}/assets/icons/technology_icon/PostSql.svg`,
  Python: `${ICON_BASE_URL}/assets/icons/technology_icon/Python.svg`,
  nuxtJs: `${ICON_BASE_URL}/assets/nuxt-js.svg`,
  visualStudio: `${ICON_BASE_URL}/assets/icons/visual-studioe.svg`,
  androidStudio: `${ICON_BASE_URL}/assets/icons/Android_Studio.svg`,
  xCode: `${ICON_BASE_URL}/assets/icons/xCode.svg`,
  figma: `${ICON_BASE_URL}/assets/icons/figma.svg`,
  adobeXD: `${ICON_BASE_URL}/assets/icons/xd.svg`,
  sketchIcon: `${ICON_BASE_URL}/assets/icons/sketch.svg`,
  SQLite: `${ICON_BASE_URL}/assets/icons/technology_icon/SQLite.svg`,
  ourServicesIcons: {
    AI_Development_Implementation: `${ICON_BASE_URL}/assets/icons/our_services_icons/AI_Development_mplementation.svg`,

    Cloud_DevOps_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_DevOps_Solutions.svg`,
    AI_Agent_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/AI Agent Development.svg`,
    Mobile_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Mobile_App_Development.svg`,
    Web_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_App_Development.svg`,
    Project_Strategy_Consultation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Project_Strategy_Consultation.svg`,
    Custom_App_Design_and_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_App_Design_and_Development.svg`,
    Responsive_Web_Applications: `${ICON_BASE_URL}/assets/icons/our_services_icons/Responsive_Web_Applications.svg`,
    Cross_Platform_App_Migration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross-Platform_App_Migration.svg`,
    Hire_Cross_Platform_Development_Staff: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Cross_Platform_Development_Staff.svg`,
    Cross_Platform_MVP_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_Platform_MVP_App_Development.svg`,
    App_Modernization: `${ICON_BASE_URL}/assets/icons/our_services_icons/App_Modernization.svg`,
    Cross_Platform_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_Platform_App_Development.svg`,
    Enhanced_Brand_Visibility: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Brand_Visibility.svg`,
    Single_Codebase: `${ICON_BASE_URL}/assets/icons/our_services_icons/Single_Codebase.svg`,
    Efficient_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Efficient_Development.svg`,
    Faster_Time_market: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Time_market.svg`,
    Easy_Maintenance: `${ICON_BASE_URL}/assets/icons/our_services_icons/Easy_Maintenance.svg`,
    Easy_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Easy_Integration.svg`,
    Reduced_Development_Cost: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reduced_Development_Cost.svg`,
    Cloud_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Integration.svg`,
    Increased_ROI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Increased_ROI.svg`,
    Website_Redesign: `${ICON_BASE_URL}/assets/icons/our_services_icons/Website_Redesign.svg`,
    Landing_Pages: `${ICON_BASE_URL}/assets/icons/our_services_icons/Landing_Pages.svg`,
    eCommerce_Website_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Website_Design.svg`,
    WordPress_Website_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/WordPress_Website_Design.svg`,
    Static_Website_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Static_Website_Design.svg`,
    CMS_Web_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/CMS_Web_Design.svg`,
    Web_UIUX_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_UIUX_Design.svg`,
    Web_Portal_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_Portal_Design.svg`,
    Tailored_User_Experience: `${ICON_BASE_URL}/assets/icons/our_services_icons/Tailored_User_Experience.svg`,
    Availability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Availability.svg`,
    Better_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Better_Security.svg`,
    Snappy_Load_Times: `${ICON_BASE_URL}/assets/icons/our_services_icons/Snappy_Load_Times.svg`,
    Enhanced_Website_Protection: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Website_Protection.svg`,
    Improved_Ranking: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Ranking.svg`,
    eCommerce_UIUX_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_UIUX_Design.svg`,
    B2B_eCommerce_Website_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/B2B_eCommerce_Website_Development.svg`,
    Headless_Commerce_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Headless_Commerce_Solutions .svg`,
    Shopify_eCommerce_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Shopify_eCommerce_Development.svg`,
    eCommerce_Platform_Migration: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Platform_Migration.svg`,
    eCommerce_Marketplace_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Marketplace_Development.svg`,
    API_Integration_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/API_Integration_Services.svg`,
    Web3_eCommerce_Website_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web3_eCommerce_Website_Development.svg`,
    eCommerce_Portal_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Portal_Development.svg`,
    Custom_Plugin_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Plugin_Development.svg`,
    Product_Recommendations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Product_Recommendations.svg`,
    Digital_Assets_Creation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Digital_Assets_Creation.svg`,
    Customer_Service_Chatbots: `${ICON_BASE_URL}/assets/icons/our_services_icons/Customer_Service_Chatbots.svg`,
    Agentic_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Agentic_AI.svg`,
    Smart_Search: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_Search.svg`,
    Accelerated_Business_Growth: `${ICON_BASE_URL}/assets/icons/our_services_icons/Accelerated_Business_Growth.svg`,
    API_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/API_Testing.svg`,
    Assessment_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Assessment_Consulting.svg`,
    Automated_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Automated_Testing.svg`,
    Cloud_Based_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Based_Testing.svg`,
    Cost_Effectiveness: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cost_Effectiveness.svg`,
    Database_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Database_Testing.svg`,
    Enhanced_Application_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Application_Security.svg`,
    Improved_Production_Efficiency: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Production_Efficiency.svg`,
    Manual_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Manual_Testing.svg`,
    Performance_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Performance_Testing.svg`,
    Protection_Sensitive_Data: `${ICON_BASE_URL}/assets/icons/our_services_icons/Protection_Sensitive_Data.svg`,
    Seamless_Scalability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Seamless_Scalability.svg`,
    Security_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Security_Testing.svg`,
    Simplification: `${ICON_BASE_URL}/assets/icons/our_services_icons/Simplification.svg`,
    Usability_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Usability_Testing.svg`,
    Responsive_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Responsive_Testing.svg`,
    Penetration_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Penetration_Testing.svg`,

    NFT_Exchange_Platform_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Exchange_Platform_Development.svg`,
    NFT_Fashion_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Fashion_Development.svg`,
    NFT_Game_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Game_Development.svg`,
    NFT_Integration_Exchange_Platform: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Integration_Exchange_Platform.svg`,
    NFT_Lending_Platform_Develop: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Lending_Platform_Develop.svg`,
    NFT_Smart_Contract_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Smart_Contract_Development.svg`,
    NFT_Wallet_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Wallet_Development.svg`,
    Metaverse_NFT_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Metaverse_NFT_Development.svg`,
    NFT_Music_Marketplace_Development: NFT_Music_Marketplace_Development,
    NFT_Marketplace_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Marketplace_Development.svg`,

    Market_Sales_Royalties: `${ICON_BASE_URL}/assets/icons/our_services_icons/Market_Sales_Royalties.svg`,
    Faster_Market_Entry: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Market_Entry.svg`,
    Profit_Potential: `${ICON_BASE_URL}/assets/icons/our_services_icons/Profit_Potential.svg`,
    Niche_Market_Opportunities: `${ICON_BASE_URL}/assets/icons/our_services_icons/Niche_Market_Opportunities.svg`,
    Verifiable_Authenticity: `${ICON_BASE_URL}/assets/icons/our_services_icons/Verifiable_Authenticity.svg`,
    Access_Growing_Market: `${ICON_BASE_URL}/assets/icons/our_services_icons/Access-Growing_Market.svg`,

    Blockchain_Game_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Blockchain_Game-Development_Services.svg`,
    Blockchain_Development_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Blockchain_Development_Consulting.svg`,
    Blockchain_Integration_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Blockchain_Integration_Services.svg`,
    Custom_Blockchain_AppDevelopment: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Blockchain_Ap-Development.svg`,
    Decentralization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Decentralization.svg`,
    DefiDevelopment: `${ICON_BASE_URL}/assets/icons/our_services_icons/Defi_Development.svg`,
    Efficiency_And_CostSaving: `${ICON_BASE_URL}/assets/icons/our_services_icons/Efficiency_and_Cost_Saving.svg`,
    Enterprise_Blockchain_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Blockchain_Development.svg`,
    Hyperledger_Blockchain_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hyperledger_Blockchain_Development_Services.svg`,
    ICODevelopment: `${ICON_BASE_URL}/assets/icons/our_services_icons/ICO_Development.svg`,
    Privacy: `${ICON_BASE_URL}/assets/icons/our_services_icons/Privacy.svg`,
    Smart_Contract_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_Contract_Development.svg`,
    NFT_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Development.svg`,
    Crypto_Wallet_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Crypto_Wallet_Development.svg`,
    Dapps_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Dapps_Development.svg`,
    STO_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/STO_Development.svg`,
    Ton_Blockchain_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/TON-Blockchain_Development.svg`,
    Traceability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Traceability.svg`,
    Transparency: `${ICON_BASE_URL}/assets/icons/our_services_icons/Transparency.svg`,
    Web3_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web3_Development_Services.svg`,

    Hire_PHP_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_PHP_Developers.svg`,
    Hire_Cross_Platform_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Cross_Platform_Developers.svg`,
    Hire_Java_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Java_Developers.svg`,
    Hire_Android_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Android_Developers.svg`,
    Hire_WordPress_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_WordPress_Developers.svg`,
    Hire_Kotlin_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Kotlin_Developers.svg`,
    Hire_Front_End_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Front_End_Developers.svg`,
    Hire_dot_Net_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_dot_Net_Developers.svg`,
    Hire_Web_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Web_Developers.svg`,
    Hire_Full_Stack_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Full_Stack_Developers.svg`,
    Hire_Offshore_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Offshore_Developers.svg`,
    Hire_MEAN_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_MEAN_Developers.svg`,
    Hire_iOS_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_iOS_Developers.svg`,
    Hire_AI_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_AI_Developers.svg`,
    Hire_Mobile_App_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Mobile_App_Developers.svg`,
    Hire_Dedicated_Shopify_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Dedicated_Shopify_Developers.svg`,
    Hire_Django_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Django_Developers.svg`,
    Hire_React_Native_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_React_Native_Developers.svg`,
    Hire_Flutter_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Flutter_Developers.svg`,
    Hire_React_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_React_Developers.svg`,
    Hire_MERN_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_MERN_Developers.svg`,
    Hire_Python_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Python_Developers.svg`,
    Hire_NodeJS_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_NodeJS_Developers.svg`,
    Hire_Golang_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Golang_Developers.svg`,
    Hire_eCommerce_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_eCommerce_Developers.svg`,

    Android_Wear_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Android_Wear_App_Development.svg`,
    Apple_Watch_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Apple_Watch_App_Development.svg`,
    AR_VR_Wearable_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/AR_VR_Wearable_App_Development.svg`,
    Enterprise_Wearable_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Wearable_App_Development.svg`,
    Google_Glass_Apps: `${ICON_BASE_URL}/assets/icons/our_services_icons/Google_Glass_Apps.svg`,
    IoT_Wearable_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Wearable_App_Development.svg`,
    Smart_Band_Apps: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_Band_Apps.svg`,
    Wearable_App_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wearable_App_Design.svg`,
    Wearable_Payment_Apps: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wearable_Payment_Apps.svg`,
    Fitness_Tracking_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fitness_Tracking_App_Development.svg`,
    Wearable_App_Consultation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wearable_App_Consultation.svg`,
    Gamification: `${ICON_BASE_URL}/assets/icons/our_services_icons/Gamification.svg`,
    Hands_Free_Operability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hands_Free_Operability.svg`,
    Personalized_Recommendations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Personalized_Recommendations.svg`,
    Real_Time_Accessibility: `${ICON_BASE_URL}/assets/icons/our_services_icons/Real_Time_Accessibility.svg`,
    Robust_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Robust_Security.svg`,
    Remote_Tracking: `${ICON_BASE_URL}/assets/icons/our_services_icons/Remote_Tracking.svg`,

    Custom_PWA_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_PWA_Development.svg`,
    Progressive_App_Shell_Architecture: `${ICON_BASE_URL}/assets/icons/our_services_icons/Progressive_App_Shell_Architecture.svg`,
    Quality_Assurance_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Quality_Assurance_Testing.svg`,
    PWA_Maintenance_and_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/PWA_Maintenance_and_Support.svg`,
    PWA_Performance_Optimization: `${ICON_BASE_URL}/assets/icons/our_services_icons/PWA_Performance_Optimization.svg`,
    PWA_Migration: `${ICON_BASE_URL}/assets/icons/our_services_icons/PWA_Migration.svg`,
    Progressive_Plugin_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Progressive_Plugin_Development.svg`,
    Progressive_Web_App_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Progressive_Web_App_Design.svg`,

    Re_Engaging: `${ICON_BASE_URL}/assets/icons/our_services_icons/Re_Engaging.svg`,
    App_Like_Experience: `${ICON_BASE_URL}/assets/icons/our_services_icons/App_Like_Experience.svg`,
    Connectivity_Independent: `${ICON_BASE_URL}/assets/icons/our_services_icons/Connectivity_Independent.svg`,
    Responsive: `${ICON_BASE_URL}/assets/icons/our_services_icons/Responsive.svg`,
    User_Friendly: `${ICON_BASE_URL}/assets/icons/our_services_icons/User_Friendly.svg`,
    Wider_Reach_and_Accessibility: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wider_Reach_and_Accessibility.svg`,

    Custom_IoT_Solutions_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_IoT_Solutions_Development.svg`,
    Digital_Twin_System_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Digital_Twin_System_Development.svg`,
    Hyperledger_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hyperledger_Development_Services.svg`,
    IoT_App_Maintenance_and_Support_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_App_Maintenance_and_Support_Services.svg`,
    IoT_Consulting_and_Strategy: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Consulting_and_Strategy.svg`,
    IoT_Data_Analysis_isualization: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Data_Analysis_isualization.svg`,
    IoT_Firmware_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Firmware_Development.svg`,
    IoT_Implementation: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Implementation.svg`,
    IoT_Product_QA_and_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Product_QA_and_Testing.svg`,
    IoT_Security_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Security_Services.svg`,

    Centralized_Processes: `${ICON_BASE_URL}/assets/icons/our_services_icons/Centralized_Processes.svg`,
    Connected_Ecosystems: `${ICON_BASE_URL}/assets/icons/our_services_icons/Connected_Ecosystems.svg`,
    Lower_Testing_Costs: `${ICON_BASE_URL}/assets/icons/our_services_icons/Lower_Testing_Costs.svg`,
    Simplified_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Simplified_Integration.svg`,
    Smart_User_Experience: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_User_Experience.svg`,
    Unified_Operations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Unified_Operations.svg`,

    Cloud_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Application_Development.svg`,
    Cloud_Application_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Application_Integration.svg`,
    Cloud_Consulting_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Consulting_Services.svg`,
    Cloud_Data_Platform_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Data_Platform_Development.svg`,
    Cloud_Deployment: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Deployment.svg`,
    Cloud_Infrastructure_Management: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Infrastructure_Management.svg`,
    Cloud_Native_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Native_Application_Development.svg`,
    DevOps_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/DevOps_Services.svg`,
    Legacy_Application_Modernization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Legacy_Application_Modernization.svg`,
    Managed_SRE_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Managed_SRE_Services.svg`,
    SaaS_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/SaaS_Application_Development.svg`,

    Data_Friendly_Framework: `${ICON_BASE_URL}/assets/icons/our_services_icons/Data_Friendly_Framework.svg`,
    Easy_Management: `${ICON_BASE_URL}/assets/icons/our_services_icons/Easy_Management.svg`,
    Operational_Savings: `${ICON_BASE_URL}/assets/icons/our_services_icons/Operational_Savings.svg`,
    Reliable_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reliable_Solutions.svg`,
    Scalable_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalable_Solutions.svg`,
    Secure_Data_Storage: `${ICON_BASE_URL}/assets/icons/our_services_icons/Secure_Data_Storage.svg`,

    AI_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/AI_Consulting.svg`,
    Architecture_Assessment_and_Refactoring: `${ICON_BASE_URL}/assets/icons/our_services_icons/Architecture_Assessment_and_Refactoring.svg`,
    Business_Process_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Business_Process_Consulting.svg`,
    Cloud_Migration_and_Optimization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Migration_and_Optimization.svg`,
    Cybersecurity_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cybersecurity_Consulting.svg`,
    IT_and_Business_Transformation: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_and_Business_Transformation.svg`,
    IT_Budgeting: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_Budgeting.svg`,
    IT_Infrastructure_Management: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_Infrastructure_Management.svg`,
    IT_Risk_Assessment_and_Compliance: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_Risk_Assessment_and_Compliance.svg`,
    Technology_Advisory_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Technology_Advisory_Services.svg`,

    Expertise: `${ICON_BASE_URL}/assets/icons/our_services_icons/Expertise.svg`,
    Faster_Project_Completion: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Project_Completion.svg`,
    Improved_Processes: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Processes.svg`,
    Increased_Productivity: `${ICON_BASE_URL}/assets/icons/our_services_icons/Increased_Productivity.svg`,
    Potential_Cost_Savings: `${ICON_BASE_URL}/assets/icons/our_services_icons/Potential_Cost_Savings.svg`,
    Reduced_Security_Risk: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reduced_Security_Risk.svg`,

    Infrastructure_and_DevOps_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/Infrastructure_and_DevOps_Support.svg`,
    Data_Backup_and_Recovery: `${ICON_BASE_URL}/assets/icons/our_services_icons/Data_Backup_and_Recovery.svg`,
    Help_Desk_and_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/Help_Desk_and_Support.svg`,
    Codebase_Refactoring_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Codebase_Refactoring_Services.svg`,
    Enhanced_Reliability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Reliability.svg`,
    Cost_Savings: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cost_Savings.svg`,
    Server_Monitoring: `${ICON_BASE_URL}/assets/icons/our_services_icons/Server_Monitoring.svg`,
    Module_and_Plugin_Updates: `${ICON_BASE_URL}/assets/icons/our_services_icons/Module_and_Plugin_Updates.svg`,
    Bug_Fixing_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Bug_Fixing_Services.svg`,
    Monitoring_and_Issue_Tracking: `${ICON_BASE_URL}/assets/icons/our_services_icons/Monitoring_and_Issue_Tracking.svg`,
    Ongoing_Technical_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/Ongoing_Technical_Support.svg`,
    Reconfiguration_and_Modification: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reconfiguration_and_Modification.svg`,
    Managed_IT_Support_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Managed_IT_Support_Services.svg`,
    Integration_and_Automation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Integration_and_Automation.svg`,
    Website_Maintenance_and_Support_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Website_Maintenance_and_Support_Services.svg`,
    Secure_and_Stable_App: `${ICON_BASE_URL}/assets/icons/our_services_icons/Secure_and_Stable_App.svg`,
    High_Performance: `${ICON_BASE_URL}/assets/icons/our_services_icons/High_Performance.svg`,
    Minimal: `${ICON_BASE_URL}/assets/icons/our_services_icons/Minimal.svg`,
    Extended_Software_Lifespan: `${ICON_BASE_URL}/assets/icons/our_services_icons/Extended_Software_Lifespan.svg`,

    Cost_effective: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cost_effective.svg`,
    Cross_platform: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_platform.svg`,
    Custom_Startup_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Startup_App_Development.svg`,
    Customer_engagement: `${ICON_BASE_URL}/assets/icons/our_services_icons/Customer_engagement.svg`,
    Faster_Time_to_Market: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Time_to_Market.svg`,
    Full_Cycle_Product_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Full_Cycle_Product_Development.svg`,
    hugeicons_security_lock: `${ICON_BASE_URL}/assets/icons/our_services_icons/hugeicons_security_lock.svg`,
    Managed_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Managed_Services.svg`,
    MVP_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_App_Development.svg`,
    Product_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Product_Consulting.svg`,
    Product_Discovery_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Product_Discovery_Services.svg`,
    Scalability_Startup: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalability.svg`,
    Startup_App_UXUI_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Startup_App_UXUI_Design.svg`,
    Web_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_Application_Development.svg`,
    Security_Startup: `${ICON_BASE_URL}/assets/icons/our_services_icons/Security_Startup.svg`,

    API_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/API_Development_Services.svg`,
    Cross_Platform_App_Development_EP: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_Platform_App_Development.svg`,
    Enterprise_Software_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Software_Consulting.svg`,
    Enterprise_Software_Digital_Transformation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Software_Digital_Transformation.svg`,
    Enterprise_Web_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Web_App_Development.svg`,
    MVP_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_Development_Services.svg`,
    Legacy_App_Modernization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Legacy_App_Modernization.svg`,
    Software_Integration_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Software_Integration_Services.svg`,

    Budget_friendly_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Budget_friendly_Solutions.svg`,
    Clear_Communication: `${ICON_BASE_URL}/assets/icons/our_services_icons/Clear_Communication.svg`,
    Enhanced_Productivity: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Productivity.svg`,
    Higher_Customer_Satisfaction: `${ICON_BASE_URL}/assets/icons/our_services_icons/Higher_Customer_Satisfaction.svg`,
    Improved_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Security.svg`,
    Real_Time_Data_Analysis: `${ICON_BASE_URL}/assets/icons/our_services_icons/Real_Time_Data_Analysis.svg`,
    Simplified_Operations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Simplified_Operations.svg`,
    Strategic_Planning_and_Execution: `${ICON_BASE_URL}/assets/icons/our_services_icons/Strategic_Planning_and_Execution.svg`,

    Custom_Mobile_App: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Mobile_App.svg`,
    Custom_Web_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Web_Development.svg`,
    Fully_MVP_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fully_MVP_Development.svg`,
    MVP_Consulting_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_Consulting_Services.svg`,
    MVP_Software_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_Software_Development_Services.svg`,
    Startup_MVP_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Startup_MVP_Development.svg`,
    UX_Design_and_Prototyping: `${ICON_BASE_URL}/assets/icons/our_services_icons/UX_Design_and_Prototyping.svg`,

    Adequate_Team_Distribution: `${ICON_BASE_URL}/assets/icons/our_services_icons/Adequate_Team_Distribution.svg`,
    Better_Informed_Decisions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Better_Informed_Decisions.svg`,
    Fulfill_Market_Demands_Early: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fulfill_Market_Demands_Early.svg`,
    Gather_Investor_Confidence: `${ICON_BASE_URL}/assets/icons/our_services_icons/Gather_Investor_Confidence.svg`,
    Minimize_Business_Risks: `${ICON_BASE_URL}/assets/icons/our_services_icons/Minimize_Business_Risks.svg`,
    Save_Cost_and_Resources: `${ICON_BASE_URL}/assets/icons/our_services_icons/Save_Cost_and_Resources.svg`,
    Scalable_Solutions_MVP: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalable_Solutions_MVP.svg`,
    Fast_Product_Launch_MVP: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fast_Product_Launch_MVP.svg`,

    Enhanced_Customer_Experiences_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Customer_Experiences_AI.svg`,
    Faster_Innovation_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Innovation_AI.svg`,
    Process_Automation_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Process_Automation_AI.svg`,
    Real_Time_Intelligence_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Real_Time_Intelligence_AI.svg`,
    Risk_Reduction_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Risk_Reduction_AI.svg`,
    Scalability_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalability_AI.svg`,
  },
  industryIcons: {
    AgTech: `${ICON_BASE_URL}/assets/icons/industry_icons/AgTech.svg`,
    Automotive: automotive,
    Banking_Finance: `${ICON_BASE_URL}/assets/icons/industry_icons/Banking_Finance.svg`,
    eCommerce: `${ICON_BASE_URL}/assets/icons/industry_icons/eCommerce.svg`,
    Education: `${ICON_BASE_URL}/assets/icons/industry_icons/Education.svg`,
    Entertainment: `${ICON_BASE_URL}/assets/icons/industry_icons/Entertainment.svg`,
    Finance: `${ICON_BASE_URL}/assets/icons/industry_icons/Finance.svg`,
    Fitness: industryFitness,
    Gaming: `${ICON_BASE_URL}/assets/icons/industry_icons/Gaming.svg`,
    Healthcare: `${ICON_BASE_URL}/assets/icons/industry_icons/Healthcare.svg`,
    Insurance: `${ICON_BASE_URL}/assets/icons/industry_icons/Insurance.svg`,
    Logistics: `${ICON_BASE_URL}/assets/icons/industry_icons/Logistics.svg`,
    Manufacturing: `${ICON_BASE_URL}/assets/icons/industry_icons/Manufacturing.svg`,
    Oil_Gas: `${ICON_BASE_URL}/assets/icons/industry_icons/Oil_Gas.svg`,
    On_Demand: `${ICON_BASE_URL}/assets/icons/industry_icons/On-Demand.svg`,
    Real_Estate: `${ICON_BASE_URL}/assets/icons/industry_icons/Real_Estate.svg`,
    Restaurant: `${ICON_BASE_URL}/assets/icons/industry_icons/Restaurant.svg`,
    Social_Networking: `${ICON_BASE_URL}/assets/icons/industry_icons/Social_Networking.svg`,
    Transportation_Logistics: `${ICON_BASE_URL}/assets/icons/industry_icons/Transportation_Logistics.svg`,
    Travel: `${ICON_BASE_URL}/assets/icons/industry_icons/Travel.svg`,
    Events_Tickets: `${ICON_BASE_URL}/assets/icons/industry_icons/Events_Tickets.svg`,
    Dating: `${ICON_BASE_URL}/assets/icons/industry_icons/Dating.svg`,
    sports: industrySports,

    White_Label_Restaurant_App: `${ICON_BASE_URL}/assets/icons/industry_icons/White_Label_Restaurant_App.svg`,
    Restaurant_App_Consultation: `${ICON_BASE_URL}/assets/icons/industry_icons/Restaurant_App_Consultation.svg`,
    Restaurant_App_UIUX_Design: `${ICON_BASE_URL}/assets/icons/industry_icons/Restaurant_App_UIUX_Design.svg`,
    Custom_Mobile_App_Development: `${ICON_BASE_URL}/assets/icons/industry_icons/Custom_Mobile_App_Development.svg`,
    Web_App_Development_FDI: `${ICON_BASE_URL}/assets/icons/industry_icons/Web_App_Development_FDI.svg`,
    API_Integration: `${ICON_BASE_URL}/assets/icons/industry_icons/API_Integration.svg`,
    Quality_Assurance: `${ICON_BASE_URL}/assets/icons/industry_icons/Quality_Assurance.svg`,
    Deployment_FDI: `${ICON_BASE_URL}/assets/icons/industry_icons/Deployment_FDI.svg`,
    Support_and_Maintenance: `${ICON_BASE_URL}/assets/icons/industry_icons/Support_and_Maintenance.svg`,
  },
  statisticIcons: {
    badge: `${ICON_BASE_URL}/assets/icons/statistic-icons/badge.svg`,
    appDownload: `${ICON_BASE_URL}/assets/icons/statistic-icons/app-download.svg`,
    appDelivered: `${ICON_BASE_URL}/assets/icons/statistic-icons/app-delivered.svg`,
    happyClients: `${ICON_BASE_URL}/assets/icons/statistic-icons/happy_clients.svg`,
  },
  AboutUsNewIcons: {
    aboutUsNew1: `${ICON_BASE_URL}/assets/icons/about-us-new-1.svg`,
    aboutUsNew2: `${ICON_BASE_URL}/assets/icons/about-us-new-2.svg`,
    aboutUsNew3: `${ICON_BASE_URL}/assets/icons/about-us-new-3.svg`,
    aboutUsNew4: `${ICON_BASE_URL}/assets/icons/about-us-new-4.svg`,
  },
  industryBenifit: {
    insights: `${ICON_BASE_URL}/assets/icons/industry-benifit/insights.svg`,
    optimusResource: `${ICON_BASE_URL}/assets/icons/industry-benifit/optimus-resource.svg`,
    broaderClientele: `${ICON_BASE_URL}/assets/icons/industry-benifit/broader-clientele.svg`,
    personalizedBranding: `${ICON_BASE_URL}/assets/icons/industry-benifit/personalized-branding.svg`,
    marketingOpportunities: `${ICON_BASE_URL}/assets/icons/industry-benifit/marketing-opportunities.svg`,
    customerExperience: `${ICON_BASE_URL}/assets/icons/industry-benifit/customer-experience.svg`,
  },
  industryServices: {
    web: `${ICON_BASE_URL}/assets/icons/industry-services/web.svg`,
    mobile: `${ICON_BASE_URL}/assets/icons/industry-services/mobile.svg`,
    backend: `${ICON_BASE_URL}/assets/icons/industry-services/backend.svg`,
    uiUx: `${ICON_BASE_URL}/assets/icons/industry-services/ui-ux.svg`,
  },
  presentationTabs: {
    customer: `${ICON_BASE_URL}/assets/icons/presentation-tabs/customer.svg`,
    customerGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/customer-gray.svg`,
    shop: `${ICON_BASE_URL}/assets/icons/presentation-tabs/shop.svg`,
    shopGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/shop-gray.svg`,
    admin: `${ICON_BASE_URL}/assets/icons/presentation-tabs/admin.svg`,
    adminGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/admin-gray.svg`,
    driver: `${ICON_BASE_URL}/assets/icons/presentation-tabs/driver.svg`,
    driverGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/driver-gray.svg`,
  },
  laravel: {
    custom_laravel_web: `${ICON_BASE_URL}/assets/icons/laravel/custom-larawel.svg`, // ← note original typo
    intutivecrm: `${ICON_BASE_URL}/assets/icons/laravel/intutive-crm.svg`, // ← note spelling
    laravel_cms: `${ICON_BASE_URL}/assets/icons/laravel/laravel-cms.svg`,
    laravel_web_development: `${ICON_BASE_URL}/assets/icons/laravel/larawel-web-development.svg`,

    hiring: {
      fullTime: `${ICON_BASE_URL}/assets/icons/laravel/full-time.svg`,
      partTime: `${ICON_BASE_URL}/assets/icons/laravel/part-time.svg`,
      hourly: `${ICON_BASE_URL}/assets/icons/laravel/hourly.svg`,
    },

    projectModels: {
      timeMaterial: `${ICON_BASE_URL}/assets/icons/laravel/time_material.svg`,
      fixedPrice: `${ICON_BASE_URL}/assets/icons/laravel/fixed-price.svg`,
    },

    reasons: {
      resultDriven: `${ICON_BASE_URL}/assets/icons/laravel/result-driven.svg`,
      provenExperience: `${ICON_BASE_URL}/assets/icons/laravel/proven-experience.svg`,
      attentionToDetails: `${ICON_BASE_URL}/assets/icons/laravel/attention.svg`,
      affordableSolutions: `${ICON_BASE_URL}/assets/icons/laravel/affordable.svg`,
      specializedTechnicalTeam: `${ICON_BASE_URL}/assets/icons/laravel/specialized-technical.svg`,
      bestInClassSupport: `${ICON_BASE_URL}/assets/icons/laravel/best-in-class.svg`,
    },

    benefits: {
      robust: `${ICON_BASE_URL}/assets/icons/laravel/robust.svg`,
      unified: `${ICON_BASE_URL}/assets/icons/laravel/unified.svg`,
      easyDeployment: `${ICON_BASE_URL}/assets/icons/laravel/easy-deployment.svg`,
      realTime: `${ICON_BASE_URL}/assets/icons/laravel/real-time.svg`,
      seemlessIntegration: `${ICON_BASE_URL}/assets/icons/laravel/seemless-integration.svg`,
      effectiveDatabase: `${ICON_BASE_URL}/assets/icons/laravel/effective-database.svg`,
      simpleError: `${ICON_BASE_URL}/assets/icons/laravel/simple-error.svg`,
      elaboratedPackage: `${ICON_BASE_URL}/assets/icons/laravel/elaborated-package.svg`,
    },
  },
  industry1: `${ICON_BASE_URL}/assets/icons/laravel-page/about/custom-laravel-development.svg`,
  industry2: `${ICON_BASE_URL}/assets/icons/laravel-page/about/laravel-web-development.svg`,
  industry3: `${ICON_BASE_URL}/assets/icons/laravel-page/about/enterprise-solution.svg`,
  industry4: `${ICON_BASE_URL}/assets/icons/laravel-page/about/intuitive-crm-development.svg`,
  contactUs: {
    dubai: `${ICON_BASE_URL}/assets/icons/dubai.svg`,
    dubaiFlag: `${ICON_BASE_URL}/assets/icons/dubai-flag.svg`,
  },
} as const;
